
import { defineComponent, PropType } from 'vue'

import NewTableRow from './NewTableRow.vue'
import NewCheckbox from '@/common/new-components/NewCheckbox/index.vue'

export default defineComponent({
    components: {
        NewTableRow,
        NewCheckbox,
    },
    props: {
        columns: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        rows: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        selectedRows: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
        nestedRows: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        selectedNested: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
        nestedRowsExpandKey: {
            type: String,
            default: null,
        },
        hasCheckboxColumn: {
            type: Boolean,
            default: false,
        },
        hasIndexColumn: {
            type: Boolean,
            default: false,
        },
        expandedRows: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
        clickableNested: {
            type: Boolean,
            default: false,
        },
        isCentered: {
            type: Boolean,
            default: false,
        },
        isOneWord: {
            type: Boolean,
            default: false,
        },
        clickableRow: {
            type: Boolean,
            default: false,
        },
        isCheckboxDisabled: {
            type: Boolean,
            default: false,
        },
        regularTable: {
            type: Boolean,
            default: false,
        },
        isBold: {
            type: Boolean,
            default: false,
        },
        nowrap: {
            type: Boolean,
            default: false,
        },
        summaryRow: {
            type: Boolean,
            default: false,
        }
    },
    emit: [
        'select-row',
        'unselect-row',
        'select-nested',
        'unselect-nested',
        'select-all',
        'click-nested',
        'click-row',
    ],
    setup(props, { emit }) {
        const isRowSelected = (row: any) => {
            return props.selectedRows.includes(row.id)
        }

        const onSelectRow = (row: any) => {
            if (isRowSelected(row)) {
                emit('unselect-row', { ...row })
            } else {
                emit('select-row', { ...row })
            }
        }

        const isNestedSelected = (row: any) => {
            return props.selectedNested.includes(row.id)
        }

        const onSelectNested = (row: any) => {
            if (isNestedSelected(row)) {
                emit('unselect-nested', { ...row })
            } else {
                emit('select-nested', { ...row })
            }
        }

        const isNestedRowExpanded = (nestedRow: any) => {
            return props.expandedRows.includes(nestedRow.id)
        }

        const onSelectAll = () => {
            emit('select-all')
        }

        const onNestedRowClick = (row: any) => {
            emit('click-nested', row)
        }

        const onRowClick = (row: any) => {
            emit('click-row', row)
        }

        return {
            isNestedRowExpanded,
            isRowSelected,
            onSelectRow,
            isNestedSelected,
            onSelectNested,
            onSelectAll,
            onNestedRowClick,
            onRowClick,
        }
    },
})
